import { gql } from '@apollo/client'

export const GET_ADMIN_SETTING = gql`
  query getAdminSetting($key: String!) {
    getAdminSetting(key: $key) {
      key
      value
      updatedAt
      updatedBy
    }
  }
`

export const LIST_ADMIN_SETTINGS = gql`
  query listAdminSettings {
    listAdminSettings {
      key
      value
      updatedAt
      updatedBy
    }
  }
`
